import React, { useState, useContext } from 'react';
import { TextField, Autocomplete, InputAdornment, Box, Typography, Chip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { TagsContext } from '../contexts/TagsContext';

const SearchField = (props) => {
  const { tags } = useContext(TagsContext);
  const { value } = props

  const handleChange = (event, newValue) => {
    props.onChange(newValue); // Call the onChange callback function
  };

  return (
    <Autocomplete
      multiple
      options={tags}
      getOptionLabel={(option) => option.name}
      // disableCloseOnSelect={true}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Busca por tags"
          placeholder=""
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
                {params.InputProps.startAdornment}
              </>
            ),
          }}
        />
      )}
      renderOption={(props, option) => (
        <Box {...props} component="li" px={2} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography component="div" sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <span>{option.name}</span>
            {option.usage_count > 0 && (
              <Chip label={option.usage_count} variant="outlined" size="small" />
            )}
          </Typography>
        </Box>
      )}
      value={value}
      onChange={handleChange}
    />
  );
};

export default SearchField;